/**
 * Find the nearest ancestor that actually scrolls vertically.
 *
 * The log views nest several `overflow-y-auto` containers, and which one ends
 * up scrolling depends on how heights resolve at runtime — so we walk up until
 * we find one that is genuinely overflowing instead of trusting class names.
 */
export function getScrollParent(el: HTMLElement | null): HTMLElement | null {
  let node = el?.parentElement ?? null;
  while (node) {
    const { overflowY } = window.getComputedStyle(node);
    if (/(auto|scroll|overlay)/.test(overflowY) && node.scrollHeight > node.clientHeight) {
      return node;
    }
    node = node.parentElement;
  }
  return (document.scrollingElement as HTMLElement | null) ?? null;
}
